










import Vue from 'vue';
import CustomType from '../../src/types/vue';

export interface ComponentApp extends Vue {

}

var component: Vue.ComponentOptions<ComponentApp> = {
  name: 'Footer',
  props: {
  },
  data() {
    return {
    }
  },
  methods: {

  },
  components: {

  },
}

export default component;



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/modules/Footer.vue